<template>
  <b-card>
    <b-tabs>
      <b-tab
        :title="$t('Link')"
        active
      >
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="$t('Affiliate link')"
                label-for="affiliate-link"
              >
                <b-input-group>
                  <b-form-input
                    id="affiliate-link"
                    v-model="affiliate.link"
                    disabled
                  />
                  <b-input-group-append>
                    <b-button
                      v-clipboard:copy="affiliate.link"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      variant="outline-primary"
                    >
                      <feather-icon icon="CopyIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!--/ instagram -->
          </b-row>
        </b-form>
      </b-tab>
      <b-tab
        :title="$t('Referral users')"
      >
        <affiliate-users />
      </b-tab>
      <b-tab
        :title="$t('Affiliate')"
      >
        <affiliates />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BRow, BCol, BCard, BTabs,
  BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import AffiliateUsers from '../../../views/affiliate-users/Index'
import Affiliates from '../../../views/affiliates/Index'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BTabs,
    BTab,
    AffiliateUsers,
    Affiliates,
  },
  directives: {
    Ripple,
  },
  props: {
    user: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      affiliate: { link: '' },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$http.get(`affiliates/${this.user.id}/info`).then(({ data }) => {
        this.affiliate = data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onCopy() {
      this.showSuccessNotification(this.$t('Copied'))
    },
    onError() {
      this.showErrorNotification(this.$t('Not copied'))
    },
  },
}
</script>
